<template>
<div class="chapter">
<div class="inner_page">
<h1>ACKNOWLEDGMENTS</h1>
<p class="acknowledgements">To my literary agent extraordinaire, <strong>ANGELA MILLER</strong>, for championing the art of storytelling.</p>
<p class="acknowledgements">To <strong>BILL LEBLOND</strong> and <strong>AMY TREADWELL</strong>, for believing in my voice and vision. And for <strong>SUPRIYA KALIDAS</strong> for guiding my creative spirit—and love of good food—in such a cool and stylish way.</p>
<p class="acknowledgements">To <strong>REBECCA SHERMAN</strong>, for always being there to help me get my publishing projects not just up on their feet, but running.</p>
<p class="acknowledgements">To <strong>JOY &amp; KIRK KIRKSEY</strong>, for sharing some cool casserole wares for photography.</p>
<p class="acknowledgements">And to my husband, <strong>ROBERT PEACOCK</strong>, whose love of food and family truly shines.</p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// 07_acknowledgments.vue?2c80e8da